import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { questions } from '../data/questions';
import { Answers } from '../utils/diagnosis';
import { QuizProgress } from './QuizProgress';
import { QuizQuestion } from './QuizQuestion';
type QuizProps = {
  step: number;
  answers: Answers;
  onAnswer: (value: string) => void;
  onBack: () => void;
};
export function Quiz({
  step,
  answers,
  onAnswer,
  onBack
}: QuizProps) {
  const question = questions[step];
  return <section className="flex min-h-[100svh] w-full flex-col bg-white px-6 pb-16 pt-10 sm:px-10" data-id="element-60" data-mp="20hdsbugsobh5">
      <div className="mx-auto w-full max-w-xl" data-id="element-61" data-mp="24gwcgo0skiix">
        <div className="flex items-center justify-between" data-id="element-62" data-mp="24kaf7xddatqw">
          <button type="button" onClick={onBack} className="-ml-2 flex items-center gap-2 rounded-full px-2 py-2 text-xs uppercase tracking-[0.18em] text-warmgray-500 transition-colors duration-500 hover:text-sage-700" data-id="element-63" data-mp="29httuydz98jd">
            <ArrowLeftIcon className="h-4 w-4" strokeWidth={1.25} data-id="element-64" data-mp="36tq741kmjt4x" />
            Atrás
          </button>
          <span className="font-serif text-sm italic text-warmgray-400" data-id="element-65" data-mp="31tu2q180lzou">
            Diagnóstico de piel
          </span>
        </div>

        <div className="mt-10" data-id="element-66" data-mp="2wtfw8nm2axsx">
          <QuizProgress current={step + 1} total={questions.length} data-id="element-67" data-mp="2rvxupiadjkuy" />
        </div>
      </div>

      <div className="mx-auto flex w-full max-w-xl flex-1 items-center py-14" data-id="element-68" data-mp="2ryac9uc7zt7h">
        <div className="w-full" data-id="element-69" data-mp="2nvng5h8inm4h">
          <AnimatePresence mode="wait" data-id="element-70" data-mp="2j3vunl47w6l7">
            <motion.div key={question.id} initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0,
            y: -8
          }} transition={{
            duration: 0.45,
            ease: [0.22, 1, 0.36, 1]
          }} data-id="element-71" data-mp="2j2ua8q1ba7qt">
              <QuizQuestion question={question} selected={answers[question.id]} onSelect={onAnswer} data-id="element-72" data-mp="246v25fe7c7lo" />
            </motion.div>
          </AnimatePresence>
        </div>
      </div>

      <p className="mx-auto w-full max-w-xl text-center text-xs font-light text-warmgray-400" data-id="element-73" data-mp="1pi35m9kdr112">
        Tus respuestas son privadas y se usan solo para orientar tu rutina.
      </p>
    </section>;
}